/** What a key press in the chat composer does. */
export type ComposerKeyAction = 'send' | 'steer' | 'none';

/**
 * Enter sends (or, while a reply streams, queues for after it); Shift+Enter
 * is a newline. While queueing, Ctrl/⌘+Enter steers: the message joins the
 * reply after its current step (AI-518).
 */
export function composerKeyAction(
  key: { key: string; shiftKey: boolean; metaKey: boolean; ctrlKey: boolean },
  queueing: boolean,
  canSteer: boolean,
): ComposerKeyAction {
  if (key.key !== 'Enter' || key.shiftKey) return 'none';
  if (queueing && canSteer && (key.metaKey || key.ctrlKey)) return 'steer';
  return 'send';
}

/**
 * Whether the composer may submit now. While a reply streams, a message can
 * only queue behind it on a known thread, and a screenshot can't be taken.
 * A file still uploading stays in the composer until it finishes.
 */
export function canSubmitMessage(state: {
  hasText: boolean;
  isAnnotating?: boolean;
  isLoading: boolean;
  canQueue: boolean;
  uploading?: boolean;
}): boolean {
  if (state.uploading) return false;
  if (!state.hasText && !state.isAnnotating) return false;
  if (!state.isLoading) return true;
  return state.canQueue && !state.isAnnotating;
}
